// src/components/lessons/renderers/ParagraphRenderer.jsx
import React from 'react';

const ParagraphRenderer = ({ block, isMobile }) => {
  const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };

  return (
    <p style={{
      color: '#000000',
      marginBottom: isMobile ? '1rem' : '1.5rem',
      lineHeight: isMobile ? '1.65' : '1.7',
      fontSize: isMobile ? '0.9375rem' : '1rem',
      opacity: 0.85
    }}>
      {processText(block.text)}
    </p>
  );
};

export default ParagraphRenderer;